/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementOptionSaveViewModel } from "../types/CourseRegistrationManagementOptionSaveViewModel.ts";
import { eEnrollmentStatusSchema } from "./eEnrollmentStatusSchema.ts";

export const courseRegistrationManagementOptionSaveViewModelSchema = z.object({
  courseRegistrationId: z.optional(
    z.number().int().describe("ID da matrícula a ser gerenciada. Obrigatório."),
  ),
  courseId: z.optional(
    z.number().int().describe("ID do curso ao qual a matrícula pertence."),
  ),
  companyId: z
    .number()
    .int()
    .describe("ID da empresa vinculada à matrícula. Opcional.")
    .nullish(),
  sellerId: z
    .number()
    .int()
    .describe("ID do vendedor responsável pela matrícula. Opcional.")
    .nullish(),
  statusReasonId: z
    .number()
    .int()
    .describe("ID do motivo de status da matrícula. Opcional.")
    .nullish(),
  subStatusReasonId: z
    .number()
    .int()
    .describe("ID do sub-motivo de status da matrícula. Opcional.")
    .nullish(),
  observation: z
    .string()
    .describe("Observação adicional sobre a alteração de status. Opcional.")
    .nullish(),
  sendNotification: z.optional(
    z
      .boolean()
      .describe("Define se uma notificação deve ser enviada ao aluno."),
  ),
  enrollmentStatus: z.optional(
    z
      .lazy(() => eEnrollmentStatusSchema)
      .describe(
        "1 = PaymentSelection | 2 = PaymentPending | 3 = ApprovalPending | 4 = Approved | 5 = Activating | 6 = Active | 7 = Transferred | 8 = TransferredInRegistration | 9 = Canceled | 10 = CanceledInRegistration | 11 = Rejected | 12 = FinishedWithPendencies | 13 = Finished | 14 = FinishedWithMonograph | 15 = FinishedWithCertificate | 16 = Blocked | ",
      ),
  ),
  enrollmentStatusText: z
    .string()
    .describe("Texto descritivo do status da matrícula.")
    .nullish(),
  available: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a opção de gerenciamento está disponível para o status atual.",
      ),
  ),
  sendCertificateOfCompletionByEmail: z.optional(
    z
      .boolean()
      .describe(
        "Define se o certificado de conclusão deve ser enviado por e-mail ao aluno.",
      ),
  ),
  courseOrClassStudentHasCertificate: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o curso ou a turma do aluno possui certificado configurado.",
      ),
  ),
  interestNewContact: z.optional(
    z
      .boolean()
      .describe(
        "Define se deve ser criado um novo contato de interesse para o aluno.",
      ),
  ),
  interestFutureProspect: z.optional(
    z
      .boolean()
      .describe("Define se o aluno deve ser marcado como prospecto futuro."),
  ),
  interestScheduleDate: z
    .string()
    .datetime()
    .describe("Data agendada para o novo contato de interesse. Opcional.")
    .nullish(),
}) as unknown as ToZod<CourseRegistrationManagementOptionSaveViewModel>;
